// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__VmwLT","loadingShrink":"PageLoading_loadingShrink__1dwP9"};